import { Departure, ShipTranslation } from '../data.ts'
import { ShipIcon } from '../icons/ship.tsx'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogTrigger } from './ui/dialog.tsx'
import { stripHTML } from '../lib/html.ts'
import { DialogTranslationContent } from './dialog.tsx'
import { useMemo } from 'react'

export function ShipInformation ({ departure, translation }: {
  departure: Departure
  translation?: ShipTranslation
}): JSX.Element {
  const { t } = useTranslation('widget')
  const hasTranslatedContent = useMemo(() => (
    translation != null && translation.image_urls.length > 0 && translation.description != null
  ), [translation])
  return (
    <div
      className='bg-white border border-brand-primary-light rounded-[5px] p-4 flex justify-between flex-col @desktop:flex-row gap-4'
    >
      <div className='flex gap-4 @desktop:items-center grow flex-col @desktop:flex-row items-start overflow-hidden'>
        <div className='flex gap-4'>
          <div><ShipIcon className='size-6 text-brand-primary' /></div>
          <h4 className='text-brand-primary font-bold whitespace-nowrap'>{translation?.name ?? departure.ship.name}</h4>
        </div>
        <div
          className='grow'
        >
          <div
            className='line-clamp-1'
            dangerouslySetInnerHTML={{ __html: stripHTML(translation?.description ?? '') }}
          />
        </div>
      </div>
      <div>
        {hasTranslatedContent && translation != null && (
          <Dialog>
            <DialogTrigger
              className='font-bold text-brand-primary underline cursor-pointer whitespace-nowrap'
            >{t('view_ship', 'View ship')}
            </DialogTrigger>
            <DialogTranslationContent translation={translation} />
          </Dialog>
        )}
      </div>
    </div>
  )
}
